import {IDotAccessor} from '@src/@interfaces/services/DotAccessor/IDotAccessor';
import app from '@src/helpers/app';
import {Join, PathsToStringProps} from '@src/@types/dot-notation';

type Path<T> = Join<PathsToStringProps<T>, '.'>;

type ValueReceiver<T> = (item: T, index: number) => any;

export default function arrayUnique<T>(
    array: [...T[]],
    byFieldName: Path<T> | ValueReceiver<T> | null = null,
): T[] {
    const result: T[] = [];
    const byField = byFieldName != null;

    const get = (() => {
        let accessor: IDotAccessor | undefined;

        return (iterable: Record<any, any> | any[], key: string) => {
            accessor ??= app('dot-accessor');

            return accessor.get(iterable, key);
        };
    })();

    const existsValues = new Set<any>();
    array.forEach((item, index) => {
        let value: any = item;
        if (byField && item != null && typeof item === 'object') {
            if (typeof byFieldName === 'string') {
                value = get(item, byFieldName);
            } else {
                value = (byFieldName as ValueReceiver<T>)(item, index);
            }
        }

        if (!existsValues.has(value)) {
            result.push(item);
            existsValues.add(value);
        }
    });

    existsValues.clear();

    return result;
}
